import { useRecordContext, ImageField } from "react-admin";

const PreviewImage = ({ source }) => {
  let record = useRecordContext();
  if (record.undefined) {
    record = {
      [source]: record.undefined,
    };
  }
  return <ImageField source={source} record={record} title=" Image" />;
};

export default PreviewImage;
